import CitySEOHead from "@/components/feature/CitySEOHead";
import AustinHeroSection from "./components/HeroSection";
import AustinStickyNav from "./components/StickyNav";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityProcessingTimeSection from "@/pages/city-template/components/CityProcessingTimeSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityTravelTimingSection from "@/pages/city-template/components/CityTravelTimingSection";
import CityDestinationsSection from "@/pages/city-template/components/CityDestinationsSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityFAQSection from "@/pages/city-template/components/CityFAQSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { austinConfig } from "./data";

const areaServedList = [
  { "@type": "City", name: "Austin" },
  { "@type": "City", name: "Round Rock" },
  { "@type": "City", name: "Cedar Park" },
  { "@type": "City", name: "Pflugerville" },
  { "@type": "City", name: "Leander" },
  { "@type": "City", name: "Georgetown" },
  { "@type": "City", name: "San Marcos" },
  { "@type": "City", name: "Kyle" },
  { "@type": "City", name: "Buda" },
  { "@type": "AdministrativeArea", name: "Travis County" },
  { "@type": "AdministrativeArea", name: "Williamson County" },
  { "@type": "AdministrativeArea", name: "Hays County" },
];

const serviceAreaDesc =
  "Fast Passport Center is a registered U.S. Department of State passport courier serving Austin, Round Rock, Cedar Park, Georgetown, and all of Central Texas with expedited passport processing as fast as 24 hours. A+ BBB rated. Office located at 1005 Congress Ave, Suite 925, Austin, TX 78701 — steps from the Texas State Capitol.";

export default function AustinPage() {
  return (
    <>
      <CitySEOHead
        city="Austin"
        state="Texas"
        stateAbbr="TX"
        route="/cities/austin"
        title="Emergency Passport Austin, TX — 24-Hour Expedited Passport Service at 1005 Congress Ave | Fast Passport Center"
        description="Emergency and expedited passport services in Austin, TX — as fast as 24 hours. Registered State Dept. courier. Office at 1005 Congress Ave, Suite 925, steps from the Texas State Capitol. A+ BBB rated. No Austin passport agency needed."
        ogTitle="Emergency Passport Austin, TX — 24-Hour Expedited Passport Service | Fast Passport Center"
        ogDescription="Emergency and expedited passport services in Austin, TX — as fast as 24 hours. Registered State Dept. courier serving Silicon Hills tech workers, UT Austin students, and Central Texas families. Office at 1005 Congress Ave."
        twitterTitle="Emergency Passport Austin, TX — 24-Hour Expedited Passport Service | Fast Passport Center"
        twitterDescription="Emergency and expedited passport services in Austin, TX — as fast as 24 hours. Registered State Dept. courier at 1005 Congress Ave. A+ BBB rated."
        geoPlacename="Austin, Texas"
        geoPosition="30.2672;-97.7431"
        keywords="passport Austin TX, expedited passport Austin, emergency passport Austin Texas, fast passport Austin, Austin passport courier, 1005 Congress Ave passport, passport renewal Austin TX, UT Austin passport, AUS airport passport"
        faqs={austinConfig.faqs}
        servicesSchema={austinConfig.servicesSchema}
        statePageName="Texas"
        statePageRoute="/states/texas"
        hasPhysicalOffice
        lastModified="2026-07-18"
        ogImage="https://readdy.ai/api/search-image?query=Professional%20modern%20office%20building%20at%201005%20Congress%20Avenue%20in%20downtown%20Austin%20Texas%20with%20the%20iconic%20Texas%20State%20Capitol%20dome%20visible%20in%20the%20background%2C%20clear%20blue%20Texas%20sky%2C%20mature%20oak%20trees%20lining%20the%20street%2C%20warm%20afternoon%20sunlight%20on%20limestone%20and%20glass%20facade%2C%20professional%20corporate%20photography&width=1200&height=630&seq=austin-og-2026&orientation=landscape"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
      />

      <div className="font-sans">
        <AustinHeroSection />
        <AustinStickyNav />

        <CityLocalAreaSection
          city={austinConfig.city}
          state={austinConfig.state}
          cities={austinConfig.nearbyCitiesZips}
          benefits={austinConfig.benefits}
          internalLinks={austinConfig.internalLinks}
          officeNote={austinConfig.fpcOfficeNote}
          officeDistance={austinConfig.fpcOfficeDistance}
          officeAddress={austinConfig.fpcOfficeAddress}
          serviceAreaIntro={austinConfig.serviceAreaIntro}
          nearbyCitiesIntro={austinConfig.nearbyCitiesIntro}
          mapEmbedUrl={austinConfig.mapEmbedUrl}
          officePhone={austinConfig.officePhone}
          officeHours={austinConfig.officeHours}
          officePhotoUrl={austinConfig.officePhotoUrl}
          officePhotoAlt={austinConfig.officePhotoAlt}
          landmarks={austinConfig.landmarks}
        />

        <CityProcessingTimeSection
          city={austinConfig.city}
          state={austinConfig.state}
          options={austinConfig.processingOptions}
          intro={austinConfig.processingIntro}
          regionalAgency={austinConfig.regionalAgency}
        />

        <CityServicesSection
          city={austinConfig.city}
          intro={austinConfig.servicesIntro}
        />

        {austinConfig.travelTiming && (
          <CityTravelTimingSection
            city={austinConfig.city}
            data={austinConfig.travelTiming}
          />
        )}

        {austinConfig.destinations && (
          <section id="destinations">
            <CityDestinationsSection
              city={austinConfig.city}
              data={austinConfig.destinations}
            />
          </section>
        )}

        <section id="testimonials">
          <CityTestimonialsSection
            city={austinConfig.city}
            testimonials={austinConfig.testimonials}
            intro={austinConfig.testimonialsIntro}
          />
        </section>

        <CityAcceptanceFacilitiesSection
          city={austinConfig.city}
          facilities={austinConfig.facilities}
        />

        <CityComparisonSection
          city={austinConfig.city}
          regionalAgency={austinConfig.regionalAgency}
          rows={austinConfig.comparisonRows}
          extraColumns={austinConfig.comparisonExtraColumns}
        />

        <CityMistakesSection
          city={austinConfig.city}
          mistakes={austinConfig.mistakes}
          intro={austinConfig.mistakesIntro}
        />

        <CityHowItWorksSection
          city={austinConfig.city}
          steps={austinConfig.steps}
          intro={austinConfig.howItWorksIntro}
        />

        <CityFAQSection
          city={austinConfig.city}
          faqs={austinConfig.faqs}
          intro={austinConfig.faqIntro}
        />

        <CityHelpfulResourcesSection
          city={austinConfig.city}
          state={austinConfig.state}
          photoLocations={austinConfig.photoLocations}
          dmvLocations={austinConfig.dmvLocations}
          airports={austinConfig.airports}
          dmvWebsite={austinConfig.dmvWebsite}
          dmvLabel={austinConfig.dmvLabel}
          vitalRecordsLinks={austinConfig.vitalRecordsLinks}
        />

        <SEOCrossLinks currentRoute="/cities/austin" state="TX" />

        <CityFinalCTA />
      </div>
    </>
  );
}